import { render } from "./AuthorInfo.vue?vue&type=template&id=52ab1a88&scoped=true&ts=true"
import script from "./AuthorInfo.vue?vue&type=script&lang=ts"
export * from "./AuthorInfo.vue?vue&type=script&lang=ts"

import "./AuthorInfo.vue?vue&type=style&index=0&id=52ab1a88&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ab1a88"]])

export default __exports__